import { render } from "./user_events.html?vue&type=template&id=5172e4af&external"
import script from "./user_events.js?vue&type=script&lang=js&external"
export * from "./user_events.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__